import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

type Button = {
  title?: string;
  value: number | string;
  icon?: string;
  isDisabled?: boolean;
};

type Props = {
  items: Array<Button>;
  value?: number | string;
  isMandatory?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonGroup',
  props: {
    items: null,
    value: { default: undefined },
    isMandatory: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: number | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: Array<Button>, value: number | string, isMandatory: boolean };





const currentSelection = computed({
  get: () => props.value,
  set: (newValue?: number | string) => emit("input", newValue),
});

return { __sfc: true,emit, props, currentSelection }
}

})